import { useState } from "react";
import { MessageSquare, ArrowLeft, CheckCheck } from "lucide-react";

const fakeChats = [
  {
    id: 1,
    name: "Laura García",
    lastMessage: "¿Tienes más información del negocio?",
    timestamp: "Hace 2h",
    avatar: "https://i.pravatar.cc/150?img=32",
    messages: [
      { from: "them", text: "Hola, me interesa el SaaS que publicaste.", time: "10:45" },
      { from: "me", text: "¡Hola Laura! Claro, ¿qué te gustaría saber?", time: "10:47" },
      { from: "them", text: "¿Tienes más información del negocio?", time: "10:50" },
    ],
  },
  {
    id: 2,
    name: "Carlos Ruiz",
    lastMessage: "Gracias por responder tan rápido.",
    timestamp: "Ayer",
    avatar: "https://i.pravatar.cc/150?img=20",
    messages: [
      { from: "them", text: "Hola, ¿el restaurante sigue en venta?", time: "12:30" },
      { from: "me", text: "Sí, sigue disponible. ¿Quieres concertar una llamada?", time: "12:32" },
      { from: "them", text: "Gracias por responder tan rápido.", time: "12:35" },
    ],
  },
];

export default function Inbox() {
  const [selectedChat, setSelectedChat] = useState(null);

  return (
    <div className="flex h-[calc(100vh-100px)] bg-gray-100 rounded-xl overflow-hidden shadow-lg">
      {/* Sidebar */}
      <div className="w-full md:w-1/3 lg:w-1/4 bg-white border-r overflow-y-auto">
        <div className="px-4 py-4 border-b flex items-center gap-2">
          <MessageSquare className="w-5 h-5 text-yellow-600" />
          <h2 className="text-lg font-semibold text-gray-800">Conversaciones</h2>
        </div>
        {fakeChats.map((chat) => (
          <div
            key={chat.id}
            onClick={() => setSelectedChat(chat)}
            className={`px-4 py-3 flex items-center gap-3 cursor-pointer hover:bg-yellow-50 ${
              selectedChat?.id === chat.id ? "bg-yellow-100" : ""
            }`}
          >
            <img src={chat.avatar} alt={chat.name} className="w-10 h-10 rounded-full" />
            <div className="flex-1">
              <p className="font-medium text-gray-800">{chat.name}</p>
              <p className="text-sm text-gray-500 truncate">{chat.lastMessage}</p>
            </div>
            <span className="text-xs text-gray-400">{chat.timestamp}</span>
          </div>
        ))}
      </div>

      {/* Conversation */}
      <div className="flex-1 bg-gray-50 flex flex-col">
        {!selectedChat ? (
          <div className="flex items-center justify-center h-full text-gray-400 text-sm">
            Selecciona una conversación para empezar
          </div>
        ) : (
          <>
            <div className="px-4 py-3 border-b bg-white flex items-center gap-3">
              <button onClick={() => setSelectedChat(null)} className="md:hidden">
                <ArrowLeft className="w-5 h-5 text-gray-600" />
              </button>
              <img src={selectedChat.avatar} className="w-8 h-8 rounded-full" alt="" />
              <div>
                <p className="font-semibold text-gray-800">{selectedChat.name}</p>
                <p className="text-xs text-gray-500">Conectado recientemente</p>
              </div>
            </div>

            <div className="flex-1 p-4 space-y-3 overflow-y-auto">
              {selectedChat.messages.map((msg, idx) => {
                const isLast = idx === selectedChat.messages.length - 1;
                const isMe = msg.from === "me";

                return (
                  <div
                    key={idx}
                    className={`flex flex-col max-w-xs md:max-w-sm px-4 py-2 rounded-xl text-sm relative ${
                      isMe
                        ? "ml-auto bg-yellow-100 text-gray-800"
                        : "bg-white text-gray-700 shadow"
                    }`}
                  >
                    <span>{msg.text}</span>
                    <div className="flex items-center justify-end mt-1 gap-1 text-[11px] text-gray-500">
                      <span>{msg.time}</span>
                      {isMe && isLast && (
                        <CheckCheck className="w-4 h-4 text-blue-500" />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="border-t bg-white p-4">
              <input
                disabled
                type="text"
                placeholder="Escribe un mensaje..."
                className="w-full px-4 py-2 border rounded-xl text-sm text-gray-700 bg-gray-100 cursor-not-allowed"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
